import { Injectable } from '@angular/core';
import { PaginatorResponse, ResponseData } from '@klickdata/core/http';
import { OccasionsDates, OccasionsDatesData, OccasionsDatesService } from '@klickdata/core/resource';
import { TableHttpHelpers, TableHttpService, TableSource } from '@klickdata/core/table';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class OccasionsDatesListingService extends OccasionsDatesService implements TableHttpService<OccasionsDates> {
    public fetchData(source: TableSource<OccasionsDates>): Observable<ResponseData<OccasionsDates[]>> {
        const req = this.builder.get<OccasionsDatesData[]>(this.resourceUrl);
        TableHttpHelpers.managePagination(source.paginator, req);
        TableHttpHelpers.manageSort(source.sort, req);
        TableHttpHelpers.mapFilter(source.filter, req);
        req.param('sort', 'start_date');
        req.param('dir', 'asc');
        return req.request().pipe(
            map((res: PaginatorResponse<OccasionsDatesData[]>) => {
                return {
                    data: res.data.map((data) => this.mapOccasionDate(data)),
                    notify: res.notify,
                    paginator: res.paginator,
                };
            })
        );
    }
}
